import { usePostHog } from '@posthog/react';
import IconButton from 'components/@extended/IconButton';
import { CancelRounded } from 'components/icons';
import useAuth from 'hooks/useAuth';
import { FormattedMessage, useIntl } from 'react-intl';
import { useStopImpersonationMutation } from 'store/api/user';
import { logError } from 'utils/monitoring';

const ImpersonationIndicatorBar = () => {
    const intl = useIntl();
    const posthog = usePostHog();
    const { user, impersonateUser } = useAuth();
    const id = user?.id;
    const authUserId = user?.authUserId;
    const name = user?.name;
    const [stopImpersonation] = useStopImpersonationMutation();

    const onSubmitStopImpersonation = async () => {
        await stopImpersonation()
            .unwrap()
            .then((self) => {
                impersonateUser(self);
                posthog.capture('user_impersonation_stopped');
            })
            .catch((error) => {
                console.error(error);
                logError(error);
            });
    };

    return id && authUserId && id !== authUserId ? (
        <div className="bg-error-lighter text-fg-error flex h-9.5 w-full items-center justify-center gap-2.5 font-semibold">
            <FormattedMessage id="impersonate-acting-as" values={{ name: name }} />
            <IconButton
                size="small"
                className="text-inherit hover:text-inherit"
                aria-label={intl.formatMessage({ id: 'impersonate-stop' })}
                onClick={() => {
                    void onSubmitStopImpersonation();
                }}
            >
                <CancelRounded />
            </IconButton>
        </div>
    ) : null;
};

export default ImpersonationIndicatorBar;
